import { LabelWithInputFieldNoError } from "components/common/molecules/LabelWithInputFieldNoError";
import "./lowDefaultCoefficient.css";
import React from "react";

interface ChildProps {
  inputObj: any;
  employeeCategoryId: number;
  employeeType: string;
  payType: number;
  updateCofficientObj: (
    event: React.ChangeEvent<HTMLInputElement>,
    category: number,
    empType: string,
    payType: number,
    key: string
  ) => void;
}

const RenderInputFields: React.FC<ChildProps> = ({
  inputObj,
  employeeCategoryId,
  employeeType,
  payType,
  updateCofficientObj,
}) => {
  return (
    <>
      <td
        key={`emp-min-${employeeType}`}
        className={`form-group ${
          inputObj.minStatus ? "error-border" : ""
        }`}
      >
        <LabelWithInputFieldNoError
          key={`label-min-${employeeType}`}
          type="text"
          className="coefficient w-100 h-100 border-0 rounded-0"
          value={inputObj.min ? inputObj.min : ""}
          handleChange={(e) =>
            updateCofficientObj(
              e,
              employeeCategoryId,
              employeeType,
              payType,
              "min"
            )
          }
        />
      </td>
      <td
        key={`emp-desired-${employeeType}`}
        className={`form-group ${
          inputObj.desiredStatus ? "error-border" : ""
        }`}
      >
        <LabelWithInputFieldNoError
          key={`label-default-${employeeType}`}
          type="text"
          className="coefficient w-100 h-100 border-0 rounded-0"
          value={inputObj.desired ? inputObj.desired : ""}
          handleChange={(e) =>
            updateCofficientObj(
              e,
              employeeCategoryId,
              employeeType,
              payType,
              "desired"
            )
          }
        />
      </td>
      <td
        key={`emp-max-${employeeType}`}
        className={`form-group ${
          inputObj.maxStatus ? "error-border" : ""
        }`}
      >
        <LabelWithInputFieldNoError
          key={`label-max-${employeeType}`}
          type="text"
          className="coefficient w-100 h-100 border-0 rounded-0"
          value={inputObj.max ? inputObj.max : ""}
          handleChange={(e) =>
            updateCofficientObj(
              e,
              employeeCategoryId,
              employeeType,
              payType,
              "max"
            )
          }
        />
      </td>
    </>
  );
};

export default RenderInputFields;
